import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiButtonComponent } from '@nexus/frontend-shared-ui';
import { formatWishlistGiftCount } from '../../utils/format-wishlist-gift-count';

@Component({
  selector: 'wishlist-create-success',
  imports: [UiButtonComponent],
  templateUrl: './wishlist-create-success.component.html',
  styleUrl: './wishlist-create-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistCreateSuccessComponent {
  public readonly wishlistTitle: InputSignal<string> = input.required<string>();
  public readonly beneficiaryLabel: InputSignal<string> = input<string>('');
  public readonly itemCount: InputSignal<number> = input<number>(0);
  protected readonly giftCountLabel: Signal<string> = computed(() => formatWishlistGiftCount(this.itemCount()));
  protected readonly avatarInitial: Signal<string> = computed(() =>
    (this.beneficiaryLabel() || this.wishlistTitle()).trim().charAt(0).toLocaleUpperCase('pl-PL') || 'W');
  public readonly detailsSelected: OutputEmitterRef<void> = output<void>();
  public readonly addItemsSelected: OutputEmitterRef<void> = output<void>();

  protected handleDetailsSelected(): void {
    this.detailsSelected.emit();
  }

  protected handleAddItemsSelected(): void {
    this.addItemsSelected.emit();
  }
}
